import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-arrow-left',
  templateUrl: './icon-arrow-left.component.html',
  styleUrls: ['./icon-arrow-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowLeftComponent {}
